import { render, staticRenderFns } from "./MenuGlobalSearchInput.vue?vue&type=template&id=bd80a83a&"
import script from "./MenuGlobalSearchInput.vue?vue&type=script&lang=ts&"
export * from "./MenuGlobalSearchInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports